<template>
  <div>
    <BaseTitle :title="$t('content.student_list')" />
    <v-card class="mb-7">
      <div class="pa-5">
        <h3>{{ $t('filter') }}</h3>
        <v-row>
          <v-col cols="12" md="6">
            <v-select :items="status" :label="$t('form.status')" v-model="form.status" clearable @change="getData">
              <template #item="{item}">{{ $t(item.text) }}</template>
              <template #selection="{item}">{{ $t(item.text) }}</template>
            </v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select :items="gender" :label="$t('form.gender')" v-model="form.gender" clearable @change="getData">
              <template #item="{item}">{{ $t(item.text) }}</template>
              <template #selection="{item}">{{ $t(item.text) }}</template>
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.student_list') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div v-if="permissionButton('ROLE_STUDENT_MANAGEMENT_CREATE')">
              <!-- <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" v-if="user.roleId !== 6" @click="add">{{ $t('add') }}</v-btn>
              <v-btn color="primary" outlined class="btn-primary-custom mb-2 mb-md-0 mr-md-2" v-if="user.roleId !== 6" @click="dialogImport = true">{{
                $t('upload')
              }}</v-btn>
              <v-btn
                color="primary"
                text
                class="btn-text-custom mb-2 mb-md-0 mr-md-2"
                v-if="user.roleId !== 6"
                :loading="table.loading"
                @click="downloadTemplate"
                >{{ $t('download_template') }} <v-icon class="ml-3">mdi-download</v-icon></v-btn
              > -->
            </div>

            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in listData" :key="item.userId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="activities" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="9" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.fullName }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('form.status') }}:
                      <strong v-if="item.status" class="green--text font-italic header-content">{{ $t('form.active') }}</strong>
                      <strong v-else class="red--text font-italic header-content">{{ $t('form.noactive') }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('table.gender') }}:
                      <strong v-if="item.gender">{{ $t('form.' + item.gender.toLowerCase()) }}</strong>
                      <strong v-else>-</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="2" v-if="user.roleId !== 6">
              <div class="d-flex flex-row-reverse">
                <template>
                  <div class="pa-5">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span dark v-bind="attrs" v-on="on">
                          <svg-icon icon="ic-moreaction-black" class="mt-1" />
                        </span>
                      </template>
                      <v-list>
                        <v-list-item v-if="permissionButton('ROLE_STUDENT_MANAGEMENT_VIEW')">
                          <v-list-item-title class="text-dropdown" @click="viewItem(item)">{{ $t('view') }}</v-list-item-title>
                        </v-list-item>
                        <div v-if="permissionButton('ROLE_STUDENT_MANAGEMENT_UPDATE')">
                          <v-list-item v-if="user.roleId === 2">
                            <v-list-item-title class="text-dropdown" @click="editItem(item)">{{ $t('edit') }}</v-list-item-title>
                          </v-list-item>
                        </div>

                        <div v-if="permissionButton('ROLE_STUDENT_MANAGEMENT_DELETE')">
                          <v-list-item v-if="item.used == false && user.roleId === 2">
                            <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item)">{{ $t('table.delete') }}</v-list-item-title>
                          </v-list-item>
                        </div>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </div>
            </v-col>
            <v-col md="2" v-else>
              <div class="d-flex flex-row-reverse">
                <v-btn color="primary" class="btn-primary-custom mt-5 mb-md-0 mr-10" @click="viewItem(item)">{{ $t('view') }}</v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listData.length" />

        <!-- <v-data-table
          :headers="tableHeader"
          :items="items"
          :loading="table.loading"
          :server-items-length="items.length"
          :options.sync="table.options"
          hide-default-footer
          class="table-custom"
        >
          <template #top>
            <table-header @fetch="getData">
              <template #left>
                <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="add">{{ $t('add') }}</v-btn>
                <v-btn color="primary" outlined class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="dialogImport = true">{{
                  $t('upload')
                }}</v-btn>
                <v-btn color="primary" text class="btn-text-custom mb-2 mb-md-0 mr-md-2" @click="downloadTemplate"
                  >{{ $t('download_template') }} <v-icon class="ml-3">mdi-download</v-icon></v-btn
                >
              </template>
            </table-header>
          </template>
          <template #item.gender="{item}">
            {{ getGender(item.gender) }}
          </template>
          <template #item.status="{ item }">
            <strong v-if="item.status" class="green--text font-italic">{{ $t('active') }}</strong>
            <strong v-else class="red--text font-italic">{{ $t('inactive') }}</strong>
          </template>
          <template #item.actions="{ item }">
            <v-btn text @click="onDeleteItem(item)" v-if="item.used == false" class="mr-1 btn-action-custom"
              ><svg-icon icon="delete" class="red--text"
            /></v-btn>
            <v-btn text @click="onPopUp()" v-if="item.used == true" class="mr-1 btn-action-custom"
              ><svg-icon icon="delete" class="grey--text"
            /></v-btn>
            <v-btn text @click="viewItem(item)" class="mr-1 btn-action-custom"><svg-icon icon="view" class="primary--text"/></v-btn>
            <v-btn text @click="editItem(item)" class="btn-action-custom"><svg-icon icon="edit" class="primary--text"/></v-btn>
          </template>
          <template #no-data><NoData /></template>
        </v-data-table>
        <table-footer @fetch="getData" /> -->
      </div>
    </v-card>

    <!-- Dialog Import -->
    <v-dialog v-model="dialogImport" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('content.import_student') }}</v-card-title>
        <v-card-text>
          <form-group :name="$t('form.file')" :validator="$v.formImport.file" no-gutter>
            <template slot-scope="{ attrs }">
              <v-file-input
                :label="$t('form.file')"
                accept=".xlsx,.xls"
                chips
                show-size
                v-bind="attrs"
                small-chips
                v-model="formImport.file"
                truncate-length="15"
                @input="$v.formImport.file.$touch()"
                @blur="$v.formImport.file.$touch()"
              ></v-file-input>
            </template>
          </form-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="btn-primary-custom" outlined :disabled="loadingImport" @click="dialogImport = false">{{ $t('close') }}</v-btn>
          <v-btn color="primary btn-primary-custom" @click="importData" :loading="loadingImport">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="table.loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';
import { required } from 'vuelidate/lib/validators';
import { fileSize, fileType } from '@/validators';

const extAllowed = ['xls', 'xlsx'];

export default {
  name: 'StudentList',
  components: {
    BaseTitle,
    // TableHeader,
    // TableFooter,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'Student/items',
      status: 'Reference/itemStatus',
      gender: 'Reference/itemGender',
      currentSchool: 'Auth/currentSchool',
      user: 'Auth/user',
      permission: 'Auth/permission'
    }),
    tableHeader() {
      return [
        { text: this.$t('table.name'), value: 'fullName' },
        { text: this.$t('table.gender'), value: 'gender', width: 150 },
        { text: this.$t('table.status'), value: 'status', width: 150 },
        { text: this.$t('table.action'), value: 'actions', sortable: false, width: 150 }
      ];
    }
  },
  validations() {
    return {
      formImport: {
        file: {
          required,
          fileSize: fileSize(500),
          fileType: fileType(extAllowed)
        }
      }
    };
  },
  data: () => ({
    dialogDelete: false,
    listData: [],
    search: '',
    dialogImport: false,
    currentItem: null,
    loadingLoad: false,
    loadingImport: false,
    form: {
      status: '',
      gender: ''
    },
    formImport: {
      file: null
    },
    table: {
      loading: false,
      options: {}
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    importData() {
      this.$v.formImport.$touch();
      if (this.$v.formImport.$invalid) return false;
      this.loadingImport = true;
      this.$store
        .dispatch('Student/importData', { ...this.formImport })
        .then(({ data }) => {
          if (data.data.errorImports.length === 0) {
            this.$store.dispatch('general/showSuccessNotification', { message: data.data.message });
          } else {
            var datas = '';
            data.data.errorImports.forEach(element => {
              datas +=
                `
              ` +
                element.message +
                `
              `;
            });
            this.$store.dispatch('general/showErrorNotification', { message: datas });
          }
          // this.$store.dispatch('general/showSuccessNotification', data);
          this.getData();
          this.formImport.file = null;
          this.dialogImport = false;
          this.$v.$reset();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingImport = false));
    },
    downloadTemplate() {
      this.table.loading = true;
      this.$store
        .dispatch('Student/downloadTemplate')
        .then(response => {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `template_export_student.xlsx`;
          link.click();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.table.loading = false));
    },
    onPopUp() {
      this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_student_index') });
    },
    getData() {
      // this.table.loading = true;
      // this.$store.dispatch('Teacher/fetchList', { ...this.form, ...this.table.options }).finally(() => (this.table.loading = false));

      if (
        (this.form.status !== '' && typeof this.form.status != 'undefined') ||
        this.form.gender ||
        (this.form.gender && this.form.status !== '' && typeof this.form.status != 'undefined')
      ) {
        this.getFilter();
      } else {
        this.loadingLoad = true;
        this.$store
          .dispatch('Student/fetchList', {
            search: this.search
          })
          .then(data => (this.listData = data))
          .finally(() => (this.loadingLoad = false));
      }
    },
    getFilter() {
      if (
        (this.form.status !== '' && typeof this.form.status != 'undefined') ||
        this.form.gender ||
        (this.form.gender && this.form.status !== '' && typeof this.form.status != 'undefined')
      ) {
        this.loadingLoad = true;
        this.$store
          .dispatch('Student/fetchFilter', {
            status: this.form.status,
            gender: this.form.gender,
            search: this.search
          })
          .then(data => (this.listData = data))
          .finally(() => (this.loadingLoad = false));
      } else {
        this.getData();
      }
    },
    add() {
      this.$router.push({ name: 'CreateStudent' });
    },
    viewItem({ userId: id, userParentId }) {
      localStorage.removeItem('backUser');
      this.$router.push({ name: 'ViewStudent', params: { id: userParentId, userId: id } });
      setTimeout(() => {
        window.location.reload();
        window.scrollTo(0, 0);
      }, 50);
    },
    editItem({ userId: id, userParentId }) {
      localStorage.removeItem('backUser');
      this.$router.push({ name: 'EditStudent', params: { id: userParentId, userId: id } });
      setTimeout(() => {
        window.location.reload();
        window.scrollTo(0, 0);
      }, 50);
    },
    onDeleteItem(item) {
      this.dialogDelete = true;
      this.currentItem = item;
    },
    deleteItem() {
      if (!this.currentItem) return false;
      this.table.loading = true;
      this.$store
        .dispatch('Student/destroy', this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .finally(() => (this.table.loading = false));
    },
    getGender(item) {
      return this.$t(this.gender.find(gender => gender.value === item)?.text || '');
    }
  },
  created() {
    this.getData();
    this.$store.commit('table/RESET_PAGEABLE');
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
